export default __webpack_public_path__ + "static/media/adn4.7cfcd4bb.png";